import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onCompletion(_this__u8e3s4, action) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (onCompletion$$inlined$unsafeFlow$1())(_this__u8e3s4, action);
}
function *invokeSafely(_this__u8e3s4, action, cause, $completion) {
  try {
    yield* action(_this__u8e3s4, cause, $completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (!(cause === null) && !(cause === e)) {
        addSuppressed(e, cause);
      }
      throw e;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var ThrowingCollectorClass;
function ThrowingCollector() {
  if (ThrowingCollectorClass === VOID) {
    class $ {
      constructor(e) {
        this.d1h_1 = e;
      }
      *b1h(value, $completion) {
        throw this.d1h_1;
      }
      s1d(value, $completion) {
        return this.b1h(value, $completion);
      }
    }
    initMetadataForClass($, 'ThrowingCollector', VOID, VOID, [FlowCollector()], [1]);
    ThrowingCollectorClass = $;
  }
  return ThrowingCollectorClass;
}
function ensureActive(_this__u8e3s4) {
  if (_this__u8e3s4 instanceof ThrowingCollector())
    throw _this__u8e3s4.d1h_1;
}
var onCompletion$$inlined$unsafeFlow$1Class;
function onCompletion$$inlined$unsafeFlow$1() {
  if (onCompletion$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_onCompletion, $action) {
        this.e1h_1 = $this_onCompletion;
        this.f1h_1 = $action;
      }
      *r1d(collector, $completion) {
        try {
          yield* this.e1h_1.a1d(collector, $completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            yield* /*#__NOINLINE__*/invokeSafely(new (ThrowingCollector())(e), this.f1h_1, e, $completion);
            throw e;
          } else {
            throw $p;
          }
        }
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$1 = $completion.mc();
        var sc = new (SafeCollector())(collector, tmp$ret$1);
        try {
          yield* this.f1h_1(sc, null, $completion);
        }finally {
          sc.wc();
        }
        return Unit_instance;
      }
      a1d(collector, $completion) {
        return this.r1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    onCompletion$$inlined$unsafeFlow$1Class = $;
  }
  return onCompletion$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  ensureActive as ensureActive17z6c489wymmv,
  onCompletion as onCompletion2zzj1m13j2omp,
};
//endregion

//# sourceMappingURL=Emitters.mjs.map
